<template>
  <div class="characteristics-typeahead">
    <input
      :disabled="fetching"
      type="text"
      class="form-control"
      ref="input"
      v-model="searchStr"
      :id="id"
      placeholder="Characteristic name">
    <typeahead
      v-model="selected"
      :target="target"
      :data="characteristics"
      item-key="Label"
      force-select
    />
  </div>
</template>

<script>
import { getCharacteristicsForUuids } from '@/api/strategies'
import { Typeahead, Notification } from 'uiv'

export default {
  name: 'SelectCharacteristicsTypeahead',
  components: { Typeahead },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fetching: false,
      searchStr: '',
      characteristics: [],
      target: null,
      selected: null
    }
  },
  methods: {
    async getCharacteristics() {
      this.fetching = true
      try {
        let resp = await getCharacteristicsForUuids([])
        this.characteristics = resp
        this.fetching = false
      } catch (err) {
        Notification.notify.error({
          duration: 0,
          offsetY: 65,
          title: 'Error fetching characteristics for autocompletion',
          content: err
        })
      }
    },
    optionSelected(characteristic) {
      this.$emit('selected', characteristic.Uuid)
      this.selected = null
      this.searchStr = ''
    }
  },
  watch: {
    selected() {
      if (this.selected && this.selected.Uuid) {
        this.optionSelected(this.selected)
      }
    }
  },
  mounted() {
    this.target = this.$refs.input
    this.getCharacteristics()
  }
}
</script>

<style scoped>
.characteristics-typeahead {
  margin-bottom: 1em;
}
</style>
